import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface RegionOptions {
	regionId?: number;
}

interface QueryOptions {
	enabled?: boolean;
}

const fetchRegionById = async ({ regionId }: RegionOptions) => {
	if (!regionId) return Promise.reject("No region id");

	const url = `/store/region/${regionId}/`;

	const response = await cmsClient.get<Region>(url);
	return response.data;
};

const useRegion = (
	{ regionId }: RegionOptions,
	queryOptions: QueryOptions = { enabled: true }
) => {
	const query = useQuery(
		["regions", regionId],
		() => fetchRegionById({ regionId }),
		queryOptions
	);

	return query;
};

export default useRegion;
